import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface SecurityAlertDialogProps {
  open: boolean;
}

export default function SecurityAlertDialog({ open }: SecurityAlertDialogProps) {
  const { t } = useTranslation();

  const handleDismiss = () => {
    window.location.href = "/login";
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "warning.dark" }}>
          <WarningAmber />
          {t("securityAlert.title")}
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("securityAlert.body")}
          <br />
          <br />
          {t("securityAlert.contactAdmin")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" color="warning" onClick={handleDismiss} fullWidth>
          {t("securityAlert.signOut")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
